import React from 'react';
import PropTypes from 'prop-types';
import { Pill, PillWithIcon } from '@els/els-react--pill';

function MultiInputPill({ value, onRemove, disabled = false }) {
  if (disabled) {
    return (
      <Pill pillColor="n7" disabled aria-disabled="true" aria-label={value}>
        {value}
      </Pill>
    );
  }

  const handleKeyDown = (e) => {
    if ((e.key === 'Enter' || e.key === ' ') && !disabled) {
      e.preventDefault();
      onRemove(e);
    }
  };

  return (
    <PillWithIcon
      iconProps={{
        sprite: 'Close',
        children: 'Remove',
        onClick: onRemove,
        'aria-label': `Remove ${value}`,
        tabIndex: 0,
        role: 'button',
        onKeyDown: handleKeyDown,
      }}
      iconRight
      aria-label={`${value}, press remove to delete`}>
      {value}
    </PillWithIcon>
  );
}

MultiInputPill.propTypes = {
  value: PropTypes.string.isRequired,
  onRemove: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};

export default React.memo(MultiInputPill);
